import { Field as ChakraField, Flex, Text, TextProps } from "@chakra-ui/react";
import * as React from "react";

export interface FieldProps extends Omit<ChakraField.RootProps, "label"> {
  label?: React.ReactNode;
  helperText?: React.ReactNode;
  errorText?: React.ReactNode;
  optionalText?: React.ReactNode;
  isRequired?: boolean;
  labelProps?: TextProps;
  icon?: React.ReactNode;
}

export const Field = React.forwardRef<HTMLDivElement, FieldProps>(
  function Field(props, ref) {
    const {
      label,
      children,
      helperText,
      errorText,
      optionalText,
      isRequired,
      labelProps,
      icon,
      ...rest
    } = props;

    return (
      <ChakraField.Root ref={ref} {...rest}>
        {label && (
          <Flex alignItems="center" gap={2}>
            {icon && icon}
            {typeof label === "string" ? (
              <Text
                textStyle="xs"
                color="neutral.700"
                fontWeight="semibold"
                {...labelProps}
              >
                {label}
                {isRequired && (
                  <Text as="span" color="red.400" textStyle="xs">
                    *
                  </Text>
                )}
                <ChakraField.RequiredIndicator fallback={optionalText} />
              </Text>
            ) : (
              <Flex gap={2} align="flex-start">
                {label}{" "}
                {isRequired && (
                  <Text as="span" color="red.400" textStyle="xs">
                    *
                  </Text>
                )}
              </Flex>
            )}
          </Flex>
        )}
        {children}
        {helperText && (
          <ChakraField.HelperText>{helperText}</ChakraField.HelperText>
        )}
        {errorText}
      </ChakraField.Root>
    );
  },
);
